import React from 'react';
import { FormFeedback, FormGroup, Label, Button, Alert } from 'reactstrap';
import Select from 'react-select';

import PropTypes from 'prop-types';

export default function VendorMultiSelect({
  options,
  setHook,
  categories = [],
  handleSelectChange,
  isSubmitted,
  feedback,
  name,
  required
}) {
  const selectAll = e => {
    setHook(options);
  };

  return (
    <FormGroup>
      <Label>
        {name}
        {required ? <span style={{ color: '#bd472a' }}>*</span> : ''}
      </Label>
      <div data-testid={name + '-select'}>
        <Select
          defaultValue={[]}
          isMulti
          name="categories"
          onChange={e => handleSelectChange(e, setHook)}
          value={categories}
          options={options}
          className="basic-multi-select"
          classNamePrefix="select"
          theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              // text: 'white',
              primary25: '#253746',
              primary: '#253746',
              neutral80: 'white',
              neutral10: '#253746',
              dangerLight: '#bf6e4c'
            }
          })}
        />
      </div>
      <div className="text-right mt-2">
        <Button
          size="sm"
          className="btn btn-falcon-default"
          onClick={e => selectAll(e)}
          data-testid={name + '-select-all-btn'}
        >
          Select all
        </Button>
      </div>
      <FormFeedback
        className={isSubmitted && options.length && !categories.length ? 'd-block' : ''}
        type="invalid"
        data-testid={name + '-select-feedback'}
      >
        <Alert color="danger">Please select {feedback}.</Alert>
      </FormFeedback>
    </FormGroup>
  );
}

VendorMultiSelect.propTypes = {
  options: PropTypes.array,
  setHook: PropTypes.func,
  categories: PropTypes.array,
  handleSelectChange: PropTypes.func,
  isSubmitted: PropTypes.bool,
  feedback: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool
};
